import config from '@/config'
import axios from 'axios'

const instance = axios.create({
  baseURL: `${config.getConfig('serverUrl')}api/liff/carts`,
  timeout: 30000,
  headers: {
    AUTHORIZATION: 'Bearer xxx xxx'
  }
})

export const cartApi = {
  deleteCartById: (id) => {
    return instance.delete(`/${id}`)
  }
}
